import { Offer, Pks } from '../contracts';


export function withDefaultPks(summary: Omit<Offer, 'pks'> & { pks?: Pks }): Offer {
  return { ...summary, pks: summary.pks ?? ({} as Pks) };
}
